import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "nav"]

  connect() {
    this.buildToc()
    this.observeHeadings()
  }

  buildToc() {
    const content = this.contentTarget
    const nav = this.navTarget
    const headings = content.querySelectorAll("h2, h3")

    if (headings.length < 2) {
      nav.closest("[data-toc-wrapper]")?.classList.add("hidden")
      return
    }

    const list = document.createElement("ul")
    list.className = "space-y-2"

    headings.forEach((heading, index) => {
      // Add ID to heading if it doesn't have one
      if (!heading.id) {
        heading.id = `heading-${index}`
      }

      const li = document.createElement("li")
      const a = document.createElement("a")

      a.href = `#${heading.id}`
      a.textContent = heading.textContent
      a.dataset.tocHeadingId = heading.id
      a.className = this.linkClasses(heading.tagName)

      a.addEventListener("click", (e) => {
        e.preventDefault()
        heading.scrollIntoView({ behavior: "smooth", block: "start" })
        history.pushState(null, null, `#${heading.id}`)
      })

      li.appendChild(a)
      list.appendChild(li)
    })

    nav.appendChild(list)
  }

  linkClasses(tagName) {
    const base = "block text-sm transition-colors hover:text-emerald-600"
    const indent = {
      H2: "font-medium text-slate-700",
      H3: "pl-3 text-slate-500"
    }
    return `${base} ${indent[tagName] || ""}`
  }

  observeHeadings() {
    const content = this.contentTarget
    const headings = content.querySelectorAll("h2, h3")

    if (headings.length < 2) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id
          const link = this.navTarget.querySelector(`[data-toc-heading-id="${id}"]`)

          if (link) {
            if (entry.isIntersecting) {
              // Remove active from all links
              this.navTarget.querySelectorAll("a").forEach((a) => {
                a.classList.remove("text-emerald-600", "font-semibold")
              })
              // Add active to current
              link.classList.add("text-emerald-600", "font-semibold")
            }
          }
        })
      },
      {
        rootMargin: "-80px 0px -80% 0px",
        threshold: 0
      }
    )

    headings.forEach((heading) => observer.observe(heading))
  }
}
